import React from "react";
import Button from "../components/button";
import Layout from "../components/layout";
import MainLogo from "../images/main-logo.svg";

export default function NotFoundPage() {
  return (
    <Layout>
      <div className="container py-5">
        <div className="mb-4">
          <img
            src={MainLogo}
            alt="Alvarez Branding Co."
            style={{ width: "220px", maxWidth: "70%", height: "auto" }}
          />
        </div>

        <h1 className="mb-3">Whoops, wrong turn.</h1>
        <p className="text-muted mb-4">
          That page doesn’t exist (or may have moved). Want to head back?
        </p>
        <Button to="/">Back to home</Button>
      </div>
    </Layout>
  );
}

